export interface MarketingProjectServerResponse {
  success: boolean;
  data: {
    reviews: {
      sku: string;
      status: string;
      dh_project_id: string;
      dh_project_name: string;
      created_at: string;
    }[];
    projects: {
      [key: string]: string;
    };
    meta: {
      count: number;
      total_count: number;
      total_pages: number;
    };
  };
}

export interface MarketingProjectClientResponse {
  sku: string;
  projectId: string;
  projectName: string;
  creationDate: string;
  thumbnailUrl: string;
  status: string;
}

export enum MarketingProjectStatus {
  Draft = 'draft',
  Approved = 'approved',
}
